import React from 'react';
import ActivelyManagedPortfolio from '../../components/ActivelyManagedPortfolio/ActivelyManagedPortfolio';

const ActivelyManagedPortfolioScreen = () => {
  return (
    <div>
      <ActivelyManagedPortfolio />
    </div>
  );
};

export default ActivelyManagedPortfolioScreen;
